import styled from 'styled-components/macro';

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
